/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_CompressInputs */

const en_shortcut_keys_name_compress = /** @type {(inputs: Shortcut_Keys_Name_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compress`)
};

const fr_shortcut_keys_name_compress = /** @type {(inputs: Shortcut_Keys_Name_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compresser`)
};

const de_shortcut_keys_name_compress = /** @type {(inputs: Shortcut_Keys_Name_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompresse`)
};

const it_shortcut_keys_name_compress = /** @type {(inputs: Shortcut_Keys_Name_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimere`)
};

const ru_shortcut_keys_name_compress = /** @type {(inputs: Shortcut_Keys_Name_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компресс`)
};

const es_shortcut_keys_name_compress = /** @type {(inputs: Shortcut_Keys_Name_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimir`)
};

const zh_cn2_shortcut_keys_name_compress = /** @type {(inputs: Shortcut_Keys_Name_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`压缩`)
};

const ja_shortcut_keys_name_compress = /** @type {(inputs: Shortcut_Keys_Name_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮`)
};

const hi_shortcut_keys_name_compress = /** @type {(inputs: Shortcut_Keys_Name_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संकुचित करें`)
};

const pt_pt2_shortcut_keys_name_compress = /** @type {(inputs: Shortcut_Keys_Name_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compressa`)
};

/**
* | output |
* | --- |
* | "Compress" |
*
* @param {Shortcut_Keys_Name_CompressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_compress = /** @type {((inputs?: Shortcut_Keys_Name_CompressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_CompressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_compress(inputs)
	if (locale === "de") return de_shortcut_keys_name_compress(inputs)
	if (locale === "it") return it_shortcut_keys_name_compress(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_compress(inputs)
	if (locale === "es") return es_shortcut_keys_name_compress(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_compress(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_compress(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_compress(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_compress(inputs)
	return en_shortcut_keys_name_compress(inputs)
});